module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_j_erythristic.f5cfd5af.png";